
/**科室分类*/
export const DepartmentClass = "department_class";

